import React from 'react';
import './footer.css'

function Footer() {
  return (
    <div className='footer-Container'>
      <p>I'm Mangaluru-bred, and welcome bribes in the form of Kori-Rotti​</p>
      <hr className='seperator' />
      <p>© Copyright 2023; Made by <b><a href='https://akshayjogi.dev/'>Akshay Kumar Jogi</a></b></p>
    </div>
  )
}

export default Footer